interface Props {
  size?: number;
  color?: string;
}

const MenuCollapseIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 ${size} ${size}`}
    >
      <path
        fill={color}
        d="M10 25v-2h13v2zm16.6-1-5-5 5-5 1.4 1.4-3.6 3.6 3.6 3.6zM10 20v-2h10v2zm0-5v-2h13v2z"
      ></path>
    </svg>
  );
};

export default MenuCollapseIcon;
